// hooks/useGrupoAtivos.js
import { useState, useEffect, useMemo } from "react"
import CalcService from "src/services/calc-service"

export function useGrupoAtivos() {
  const [options, setOptions] = useState([])
  const calcService = useMemo(() => new CalcService(), [])

  useEffect(() => {
    let mounted = true

    const fetchGrupoAtivos = async () => {
      try {
        const result = await calcService.recuperaGrupoAtivos()

        // Garantir que seja uma lista de strings
        const optionsAsStrings = result.map(item => {
          if (typeof item === "string") return item
          if (item && typeof item === "object") {
            // Tenta pegar label ou value como fallback
            return item.value ?? JSON.stringify(item)
          }
          return String(item)
        })

        if (mounted) setOptions(optionsAsStrings)
      } catch (err) {
        console.error("Erro ao carregar GrupoAtivos:", err)
      }
    }

    fetchGrupoAtivos()
    return () => { mounted = false }
  }, [calcService])

  return options
}
